// components/ObyectLoader.tsx
import * as React from "react";

interface ObyectLoaderProps {
  src?: string;
  size?: number; // outer size in px
}

const ObyectLoader: React.FC<ObyectLoaderProps> = ({
  src = "/lovable-uploads/obyect_new.svg",
  size = 64,
}) => {
  const boxSize = `${size}px`;
  const innerSize = `${size / 2}px`;

  return (
    <div
      className="relative"
      style={{ width: boxSize, height: boxSize }}
      aria-busy="true"
      aria-label="Loading Obyect"
    >
      {/* Progress ring */}
      <svg
        viewBox="0 0 48 48"
        className="absolute inset-0 w-full h-full motion-safe:animate-spin"
        aria-hidden
      >
        <circle
          cx="24"
          cy="24"
          r="20"
          fill="none"
          className="stroke-muted/20"
          strokeWidth="4"
        />
        <circle
          cx="24"
          cy="24"
          r="20"
          fill="none"
          strokeWidth="4"
          strokeLinecap="round"
          className="stroke-primary"
          strokeDasharray="125.6"
          strokeDashoffset="78.5"
        />
      </svg>

      {/* Center logo */}
      {src ? (
        <img
          src={src}
          alt="Obyect"
          className="absolute inset-0 m-auto rounded-md motion-safe:animate-pulse"
          style={{ width: innerSize, height: innerSize }}
          draggable={false}
        />
      ) : (
        <div
          aria-hidden
          className="
            absolute inset-0 m-auto rounded-md
            bg-[radial-gradient(at_30%_20%,#e2466c,transparent_60%),radial-gradient(at_80%_30%,#d088ff,transparent_60%),radial-gradient(at_20%_80%,#765be6,transparent_60%),radial-gradient(at_80%_80%,#bcbdda,transparent_60%)]
            motion-safe:animate-pulse
          "
          style={{ width: innerSize, height: innerSize }}
        />
      )}
    </div>
  );
};

export default ObyectLoader;
